import { render } from "./footer.vue?vue&type=template&id=5ee4a506&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=5ee4a506&lang=scss&scoped=true"

import exportComponent from "D:\\workarea\\example\\景区旅游\\PC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee4a506"]])

export default __exports__